"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Retention = void 0;
const React = __importStar(require("react"));
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const antd_1 = require("antd");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const RetentionPopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/RetentionPopover");
const ProjectHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/highcharts/ProjectHighchartsOptionsProvider");
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const HighchartsComponentWrapper_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsComponentWrapper");
const HighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/common/content/highcharts/HighchartsOptionsProvider");
const RetentionChartSettingsJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionChartSettingsJSONModel");
const RetentionJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/model/RetentionJSONModel");
const CommonTypesConversions_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/CommonTypesConversions");
const title = "Retention";
const Retention = () => {
    var _a, _b, _c, _d, _e;
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const currentProjectDataContext = (0, ProjectDashboardDataProvider_1.useProjectDashboardDataContext)();
    const state = currentProjectDataContext.stateUpdateCalls;
    if ((_b = (_a = state.data) === null || _a === void 0 ? void 0 : _a.retention) === null || _b === void 0 ? void 0 : _b.isError) {
        return React.createElement(React.Fragment, null,
            React.createElement(PageContent_1.default.CardSection, null, title),
            React.createElement(antd_1.Result, { className: "ug-result-noIcon", status: "error", icon: React.createElement(React.Fragment, null), subTitle: React.createElement(React.Fragment, null,
                    "Oops, something went wrong.",
                    React.createElement("br", null),
                    title,
                    " cannot be loaded. Please try again.") }));
    }
    const inProgress = state.inProgress;
    const filterPeriod = (new RetentionChartSettingsJSONModel_1.RetentionChartSettingsJSONModel()).getFilterPeriodByRetentionType("nDay");
    const classicParameters = {
        ...RetentionChartSettingsJSONModel_1.RetentionChartSettingsJSONModel.getDefaultModel(),
        shouldAddPeriod: true,
        filterPeriod: filterPeriod
    };
    const defaultRetentionChartSettingsJSONModel = RetentionChartSettingsJSONModel_1.RetentionChartSettingsJSONModel.getDefaultModel();
    defaultRetentionChartSettingsJSONModel.chartType = RetentionChartSettingsJSONModel_1.ChartType.overtime;
    const overtimeParameters = {
        ...defaultRetentionChartSettingsJSONModel,
        shouldAddPeriod: false,
        filterPeriod: filterPeriod
    };
    const highchartsOptionsProviderFn = ProjectHighchartsOptionsProvider_1.ProjectHighchartsOptionsProvider.getRetention;
    const data = {
        request: {
            periodType: ProjectDashboardDataProvider_1.dashboardRetentionChunksParameters.periodType,
            retentionType: ProjectDashboardDataProvider_1.dashboardRetentionChunksParameters.retentionType,
            cohortQuery: [...ProjectDashboardDataProvider_1.dashboardRetentionChunksParameters.cohortQuery],
            returnQuery: [...ProjectDashboardDataProvider_1.dashboardRetentionChunksParameters.returnQuery]
        },
        response: (_d = (_c = state.data) === null || _c === void 0 ? void 0 : _c.retention) === null || _d === void 0 ? void 0 : _d.data
    };
    const jsonModelForURL = new RetentionJSONModel_1.RetentionJSONModel();
    jsonModelForURL.getPeriodDaysJSONModel().setLast(data.request.periodType.last);
    jsonModelForURL.getRetentionTypeJSONModel().setType(CommonTypesConversions_1.CommonTypesConversions.retentionType.retentionTypeToRetentionTypeType(data.request.retentionType));
    jsonModelForURL.getTabsJSONModel().addItem({
        cohort: CommonTypesConversions_1.CommonTypesConversions.queryEventVariants.queryEventVariantsJSONModelFromQueryEventVariant(data.request.cohortQuery).serialize(),
        return: CommonTypesConversions_1.CommonTypesConversions.queryEventVariants.queryEventVariantsJSONModelFromQueryEventVariant(data.request.returnQuery).serialize()
    }, false);
    const error = (0, DataProviderCommonTypes_1.getDataProviderStateErrorFromCommonState)((_e = state.data) === null || _e === void 0 ? void 0 : _e.retention);
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSection, null,
            React.createElement(antd_1.Space, null,
                React.createElement(react_router_dom_1.Link, { to: AppRouting_1.AppPathGenerator.Project.retention(projectApiKey, jsonModelForURL.serialize()) }, title),
                React.createElement(RetentionPopover_1.RetentionPopover, null))),
        React.createElement(antd_1.Row, { gutter: [32, 16] },
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: error, data: data, parameters: classicParameters, highchartsOptionsProviderFn: highchartsOptionsProviderFn },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    }))),
            React.createElement(antd_1.Col, { span: 24, lg: 12 },
                React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsProvider, { error: error, data: data, parameters: overtimeParameters, highchartsOptionsProviderFn: highchartsOptionsProviderFn },
                    React.createElement(HighchartsOptionsProvider_1.HighchartsOptionsContext.Consumer, null, context => {
                        return React.createElement(HighchartsComponentWrapper_1.HighchartsComponentWrapper, { highchartsOptionsState: context.state, inProgress: inProgress });
                    })))));
};
exports.Retention = Retention;
